import { render, staticRenderFns } from "./mba-nw-graph.vue?vue&type=template&id=1b3ac1e6&scoped=true&"
import script from "./mba-nw-graph.vue?vue&type=script&lang=js&"
export * from "./mba-nw-graph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3ac1e6",
  null
  
)

export default component.exports